import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware } from "redux";
import { thunk } from "redux-thunk";

export const rootMiddleware = composeWithDevTools(applyMiddleware(thunk)); // eslint-disable-line code-style/index-exports-only
